/**
 * Shared utilities for the users pages.
 */

export interface RoleRef {
  name: string;
  _id?: string;
  scope?: 'internal' | 'customer';
}

/**
 * Canonical role assignment type — matches the auth-service API.
 * customerScope: string[] means scoped to those company IDs
 * customerScope: null means all companies (no restriction)
 */
export interface RoleAssignment {
  role: string;
  customerScope: string[] | null;
}

export interface AuthRole {
  id?: string;
  _id?: string;
  name: string;
  scope?: 'internal' | 'customer';
}

/**
 * Extract the display name from a role that may be a plain string or an object.
 * The `_id` field is optional metadata present on populated role objects.
 */
export const getRoleName = (role: string | RoleRef): string =>
  typeof role === 'string' ? role : role.name;

export const getRoleScopeColor = (scope?: 'internal' | 'customer'): 'purple' | 'orange' =>
  scope === 'customer' ? 'orange' : 'purple';

export const getRoleScopeLabel = (scope?: 'internal' | 'customer'): 'Internal' | 'Customer' =>
  scope === 'customer' ? 'Customer' : 'Internal';
